import { Injectable } from '@angular/core';
import { IShellEvent } from './IShellEvent';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { OrdersNavigationService, OrdersButtonClickedPayload } from 'app/doctors/orders/orders-navigation.service';

@Injectable({ providedIn: 'root' })
export class ShellOrdersButtonClickedEvent implements IShellEvent {
	constructor(private readonly ordersNavigationService: OrdersNavigationService) {}

	get eventName(): string {
		return ShellCommunicationEvents.OrdersButtonClicked;
	}

	handleCustomEvent(event: any): void {
		const payload = event.data as OrdersButtonClickedPayload;
		this.ordersNavigationService.handleButtonClicked(payload);
	}

	handlePostMessage(_event: any): void {
		// orders-button-clicked is channel-based only; postMessage not used
	}
}
